import React from 'react';
import './auth.css';

const AuthLayout = ({ children, showImage = true, rightPanel = null }) => {
  return (
    <div className="auth-page auth-split-layout">
      {/* Left side - Content */}
      <div className="auth-content-side">
        <div className="auth-container">
          {children}
        </div>
      </div>
      
      {/* Right side - Image/Branding */}
      {rightPanel ? (
        <div className="auth-image-side" style={{ padding: 0, background: 'black' }}>
          {rightPanel}
        </div>
      ) : showImage && (
        <div className="auth-image-side">
          <div className="auth-image-overlay">
            <div className="auth-image-content">
              <h2>Welcome to Beu</h2>
              <p>The modern way to manage your beauty business and bookings</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthLayout;